import AsyncStorage from '@react-native-async-storage/async-storage';

export const CALENDAR_ANNOUNCEMENT_ID = 'google-calendar-v1';
const STORAGE_PREFIX = '@featureAnnouncement:';
const dismissedThisSession = new Set<string>();

/** Independent, device-local preferences: never touches account or timetable keys. */
export async function isFeatureAnnouncementDismissed(id: string): Promise<boolean> {
  if (dismissedThisSession.has(id)) return true;
  try {
    const key = STORAGE_PREFIX + id;
    const value = typeof window !== 'undefined'
      ? window.localStorage.getItem(key) : await AsyncStorage.getItem(key);
    // Dismissal can happen while a slow native read is still pending.
    return dismissedThisSession.has(id) || value === '1';
  } catch (error) {
    console.warn('Could not restore feature announcement preference', error);
    return dismissedThisSession.has(id);
  }
}

export async function dismissFeatureAnnouncement(id: string): Promise<void> {
  // Closing always works, even if device storage is unavailable.
  dismissedThisSession.add(id);
  try {
    const key = STORAGE_PREFIX + id;
    if (typeof window !== 'undefined') window.localStorage.setItem(key, '1');
    else await AsyncStorage.setItem(key, '1');
  } catch (error) { console.warn('Could not save feature announcement preference', error); }
}
